import { AlertTriangle, CheckCircle2, Info, X, XCircle } from 'lucide-react';
import type { ReactNode } from 'react';
import styles from './Toast.module.css';

export type ToastTone = 'success' | 'error' | 'warning' | 'info';

export type ToastAction = {
  label: string;
  onClick: () => void;
};

export type ToastProps = {
  tone: ToastTone;
  title?: string;
  message: string;
  action?: ToastAction;
  onDismiss: () => void;
};

const ICONS: Record<ToastTone, ReactNode> = {
  success: <CheckCircle2 size={18} />,
  error: <XCircle size={18} />,
  warning: <AlertTriangle size={18} />,
  info: <Info size={18} />,
};

export function Toast({ tone, title, message, action, onDismiss }: ToastProps) {
  return (
    <div className={`${styles.toast} ${styles[`tone-${tone}`]}`} role="status" aria-live="polite">
      <span className={styles.icon}>{ICONS[tone]}</span>
      <div className={styles.body}>
        {title ? <span className={styles.title}>{title}</span> : null}
        <span className={styles.message}>{message}</span>
      </div>
      {action ? (
        <button type="button" className={styles.action} onClick={action.onClick}>
          {action.label}
        </button>
      ) : (
        <button type="button" className={styles.close} onClick={onDismiss} aria-label="Fechar">
          <X size={14} />
        </button>
      )}
    </div>
  );
}
